<template>
  <div class="index">
    <!-- 中间图片部分 -->
    <div class="center">
      <img
        src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/leftOne.png"
        alt=""
        class="leftOne_bg"
      />
      <img
        src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/rightOne.png"
        alt=""
        class="rightOne_bg"
      />
      <CenterTable>
        <!-- 表格标题 -->
        <template v-slot:title>往期回顾</template>
        <!-- 表格内容部分 -->
        <template v-slot:content>
          <div class="lookBack_box">
            <!-- 回顾更多标题部分 -->
            <div class="lookBack_title">
              <div class="lookBack_title_left">
                <i class="iconfont icon-sanjiao-copy sanjiao"></i>
                <span class="No">共{{ sortlist.count }}期</span>
                <div class="newBtn">
                  <ul class="newBtn_ul">
                    <li
                      @click="statusChange(0)"
                      :class="[statusNum == 0 ? 'statusNum' : '']"
                    >
                      全部
                    </li>
                    <li
                      @click="statusChange(1)"
                      :class="[statusNum == 1 ? 'statusNum' : '']"
                    >
                      正在报名时
                    </li>
                    <li
                      @click="statusChange(2)"
                      :class="[statusNum == 2 ? 'statusNum' : '']"
                    >
                      正在进行时
                    </li>
                    <li
                      @click="statusChange(3)"
                      :class="[statusNum == 3 ? 'statusNum' : '']"
                    >
                      已结束
                    </li>
                  </ul>
                </div>
              </div>
              <div class="lookBack_title_right">
                <div class="sort_g">排序:</div>
                <div class="sort" @click="sortChange(1)">
                  <a href="javascript:;" :class="[sortNum == 1 ? 'active' : '']"
                    >时间最近</a
                  >
                </div>
                <div class="sort_heng">|</div>
                <div class="sort" @click="sortChange(2)">
                  <a href="javascript:;" :class="[sortNum == 2 ? 'active' : '']"
                    >时间最远</a
                  >
                </div>
                <div class="sort_heng">|</div>
                <div class="sort" @click="sortChange(3)">
                  <a href="javascript:;" :class="[sortNum == 3 ? 'active' : '']"
                    >互动热度</a
                  >
                </div>
                <div class="sort_heng">|</div>
                <div class="sort" @click="sortChange(4)">
                  <a href="javascript:;" :class="[sortNum == 4 ? 'active' : '']"
                    >完成率</a
                  >
                </div>
              </div>
            </div>
            <div class="lookBack_content" v-loading="loding" v-if="empty">
              <sortTable
                v-for="item in sortlist.list"
                :key="item.camp_id"
                :Mykey="item"
              ></sortTable>
              <div class="pageNun">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="sortlist.count"
                  :page-size="limit"
                  :current-page="mypage"
                  @current-change="changePage"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <!-- 空状态 -->
          <div v-if="!empty" style="width: 100%; height: 25rem">
            <div
              style="
                margin: auto;
                width: 18rem;
                height: 18rem;
                text-align: center;
              "
            >
              <img
                style="width: 90%; height: 90%"
                src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                alt=""
              />
              <div style="color: #333333">暂时没有数据</div>
            </div>
          </div>
        </template>
      </CenterTable>
    </div>
    <!-- 底部图片部分 -->
    <div class="footer">
      <!-- 第二个表格 -->
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import CenterTable from "@/components/CenterTable.vue";
import sortTable from "@/components/sortTable.vue";
export default {
  name: "index",
  components: {
    CenterTable,
    sortTable,
  },
  //status .0全部，1正在报名，2正在进行，3已结束，
  data() {
    return {
      // 显示数据的方式
      statusNum: 0,
      // 排序方式
      sortNum: 1,
      // 数据列表
      sortlist: { list: [] },
      // loading控制器
      loding: false,
      // 每一次请求多少数据
      limit: 12,
      // 当前页码
      mypage: 1,
      // 空状态
      empty: true,
    };
  },
  methods: {
    // 排序切换
    sortChange(item) {
      this.sortNum = item;
      this.loding = true;
      this.getCampPhase(this.sortNum);
    },
    // 请求往期回顾数据
    getCampPhase(mysort) {
      var sort = null;
      if (mysort) {
        sort = mysort;
      }
      this.loding = true;
      this.$axios
        .get("/getCampPhase", {
          params: {
            agency_id: this.agency_id,
            // token: this.token,
            // 请求数量
            limit: this.limit,
            // 排序方式 sort:1、时间最近  2、时间最远 3、互动热度  4、完成率(暂时没有)  「该参数可不传、后台接口默认为1，」
            sort: sort,
            // 当前页码
            page: this.mypage,
            status: this.statusNum,
          },
        })
        .then((doc) => {
          this.sortlist = doc;
          this.loding = false;
          // doc.list = []
          if (doc.list.length == 0) {
            this.empty = false;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 切换页码
    changePage(e) {
      this.mypage = e;
      this.getCampPhase();
    },
    // 切换打卡的时间段类型
    statusChange(e) {
      this.statusNum = e;
      this.getCampPhase();
    },
  },
  mounted() {
    // 判断是否传参
    if (this.$route.query.status != null) {
      let status = this.$route.query.status;
      console.log(status);
      if (status > 0 && status < 4) {
        this.statusChange(status);
      }
    }else{
      this.getCampPhase(this.listNum, this.sortNum);
    }
  },
  computed: {
    // ...mapState(["token", "agency_id"]),
    agency_id() {
      if (localStorage.getItem("agency_id")) {
        return localStorage.getItem("agency_id");
      } else {
        return 281;
      }
    },
    token() {
      if (localStorage.getItem("token")) {
        return localStorage.getItem("token");
      } else {
        return null;
      }
    },
  },
  watch: {
    mypage(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="less" scoped>
//   内容中间部分
.center {
  position: relative;
  width: 100%;
  // height: 45.4375rem;
  background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/center.png)
    no-repeat;
  background-size: 100% 100%;
  //中间表格部分
  .leftOne_bg {
    position: absolute;
    left: 0;
    top: 15%;
    z-index: 0;
    width: 15rem;
    height: 49.5rem;
  }
  .rightOne_bg {
    position: absolute;
    right: 6.1875rem;
    top: 40%;
    z-index: 0;
    width: 10.5625rem;
    height: 23.4375rem;
  }
  /deep/ .heng_box {
    width: 90.4375rem;
    .heng {
      width: 90.4375rem;
    }
    .heng_table {
      width: 82.625rem;
      padding-bottom: 1.8rem;
    }
  }

  //   往期回顾盒子
  .lookBack_box {
    box-sizing: border-box;
    padding: 0 3rem 2.9375rem 2.9375rem;
    // 往期回顾最上方标题
    .lookBack_title {
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      //主轴方向的对齐，这里是将元素左右分离
      justify-content: space-between;
      //   次轴方向的对其，这里是将元素居中在盒子中间
      align-items: center;
      padding: 0 2rem 0 2.1875rem;
      width: 100%;
      height: 5.8125rem;
      background: #ffffff;
      border: 0.0625rem solid #f1f1f1;
      border-radius: 0.5625rem;
      .lookBack_title_left {
        display: flex;
        flex-direction: row;
        align-items: center;
        .sanjiao {
          color: #ff7415;
        }
        .No {
          font-size: 1.75rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #212121;
        }

        .newBtn {
          margin-left: 0.625rem;
          height: 100%;
          .newBtn_ul {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            li {
              padding: 0 0.625rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-family: "Microsoft YaHei";
              font-weight: 400;
            }
            .statusNum {
              color: #fc5454;
            }
          }
        }
      }
      .lookBack_title_right {
        display: flex;
        flex-direction: row;
        font-size: 0.875rem;
        font-family: " Microsoft YaHei";
        font-weight: 400;
        color: #444444;
        .sort_g {
          margin-right: 0.9375rem;
        }
        .sort_heng {
          margin: 0 0.9375rem;
        }
        .sort {
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #444444;
        }
        .active {
          color: #fc5454;
        }
      }
      .sort:hover {
        a {
          color: #fc5454;
        }
      }
    }
    // 列表部分
    .lookBack_content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      /deep/ .sortTable:nth-child(n) {
        margin: 2.125rem 2.125rem 0 0;
      }
      /deep/ .sortTable:nth-child(4n) {
        margin-right: 0;
      }
    }
    // 下方页码部分
    .pageNun {
      margin-top: 6.25rem;
      height: 2.5rem;
      width: 100%;
      display: flex;
      align-content: center;
      justify-content: center;
      /deep/ .el-pagination {
        .el-pager {
          li:hover {
            color: #ff4d2a;
          }
          .active {
            background-color: #ff4d2a;
          }
          .active:hover {
            color: #fff;
          }
        }
      }
    }
  }
}
// 内容最下部分
.footer {
  width: 100%;
}
</style>